var _path, _path2, _path3, _path4, _path5, _path6, _mask, _g, _path7, _path8, _path9, _path10, _path11;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgStep7(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 170,
    height: 170,
    viewBox: "0 0 170 170",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#93C9FF",
    d: "M0 0H170V170H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M117 63.9157L87.5882 35H29C22.3726 35 17 40.3726 17 47V143C17 149.627 22.3726 155 29 155H105C111.627 155 117 149.627 117 143V63.9157Z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M132 48.9157L102.588 20H44C37.3726 20 32 25.3726 32 32V128C32 134.627 37.3726 140 44 140H120C126.627 140 132 134.627 132 128V48.9157Z",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M91 74H76V78H91V74zM95 78V74H120V78H95zM91 83H76V87H91V83zM95 87V83H120V87H95zM91 92H76V96H91V92zM95 96V92H120V96H95zM91 101H76V105H91V101zM95 105V101H120V105H95zM91 110H76V114H91V110zM95 114V110H120V114H95zM91 119H76V123H91V119zM95 123V119H120V123H95zM57 74H72V78H57V74zM57 83H72V87H57V83zM57 92H72V96H57V92zM57 101H72V105H57V101zM57 110H72V114H57V110zM57 119H72V123H57V119zM53 74H44V78H53V74zM53 83H44V87H53V83zM53 92H44V96H53V92zM53 101H44V105H53V101zM53 110H44V114H53V110zM53 119H44V123H53V119z",
    fill: "#C5E5FB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M150.778 33.9765L146.468 32.4077 144.792 26.36C144.687 25.9702 144.454 25.6256 144.13 25.3796 143.805 25.1337 143.407 25.0002 142.997 25 142.587 24.9998 142.189 25.1328 141.864 25.3785 141.539 25.6241 141.306 25.9685 141.2 26.3582L139.524 32.4059 135.217 33.9746C134.86 34.1045 134.552 34.3389 134.334 34.6462 134.117 34.9536 134 35.3191 134 35.6937 134 36.0682 134.117 36.4338 134.334 36.7411 134.552 37.0485 134.86 37.2829 135.217 37.4127L139.502 38.9759 141.191 45.6138C141.292 46.01 141.525 46.3616 141.852 46.6128 142.18 46.8639 142.583 47.0002 142.998 47 143.413 46.9998 143.816 46.8631 144.143 46.6116 144.471 46.3601 144.703 46.0083 144.804 45.612L146.493 38.9741 150.778 37.4109C151.136 37.2827 151.445 37.0492 151.664 36.742 151.883 36.4348 152 36.0688 152 35.6937 152 35.3186 151.883 34.9526 151.664 34.6454 151.445 34.3382 151.136 34.1046 150.778 33.9765zM128.316 13.6876L131.986 15.0456C132.283 15.1556 132.54 15.3541 132.721 15.6144 132.903 15.8747 133 16.1843 133 16.5015 133 16.8187 132.903 17.1283 132.721 17.3886 132.54 17.6489 132.283 17.8473 131.986 17.9573L128.314 19.3153 126.956 22.9859C126.846 23.2835 126.648 23.5402 126.387 23.7215 126.127 23.9028 125.817 24 125.5 24 125.183 24 124.873 23.9028 124.613 23.7215 124.352 23.5402 124.154 23.2835 124.044 22.9859L122.686 19.3153 119.014 17.9573C118.717 17.8473 118.46 17.6489 118.279 17.3886 118.097 17.1283 118 16.8187 118 16.5015 118 16.1843 118.097 15.8747 118.279 15.6144 118.46 15.3541 118.717 15.1556 119.014 15.0456L122.686 13.6876 124.044 10.017C124.153 9.71878 124.351 9.46132 124.612 9.27943 124.872 9.09754 125.182 9 125.5 9 125.818 9 126.128 9.09754 126.388 9.27943 126.649 9.46132 126.847 9.71878 126.956 10.017L128.316 13.6876z",
    fill: "#2255EF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.5 63C50.9396 63 44 56.0604 44 47.5C44 38.9396 50.9396 32 59.5 32C68.0604 32 75 38.9396 75 47.5C75 56.0604 68.0604 63 59.5 63Z",
    fill: "#2B63D0"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "step7_svg__svghome/circleci/project/webpack/application/components/onboarding-tour/images/step7_svga",
    maskUnits: "userSpaceOnUse",
    x: 44,
    y: 32,
    width: 31,
    height: 31
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.5 63C50.9396 63 44 56.0604 44 47.5C44 38.9396 50.9396 32 59.5 32C68.0604 32 75 38.9396 75 47.5C75 56.0604 68.0604 63 59.5 63Z",
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#step7_svg__svghome/circleci/project/webpack/application/components/onboarding-tour/images/step7_svga)",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M75 35.875L60.2373 43.2564L57.8046 47.0561L44 53.9583V59.125L59.9256 51.1622L61.281 47.9012L75 41.0417V35.875Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75 39.104L59.4452 46.8814L59.4463 48.1725L75 40.3957V39.104Z",
    fill: "#E62048"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.5566 46.3257L44 54.604V55.8957L60.5096 47.6409L60.5566 46.3257Z",
    fill: "#E62048"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44 36.521L60.9239 44.9829L61.7688 47.3429L75 53.9585V58.4793L61.33 51.6443L60.3971 49.2404L44 41.0418V36.521Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.9451 48.3687L74.9999 55.896V57.8335L59.7761 50.2216 59.9451 48.3687zM44 37.1665L61.053 45.693 59.5 46.2082 44 38.4582 44 37.1665z",
    fill: "#E62048"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.0208 32H54.9792V42.6562H44V52.3438H54.9792V63H64.0208V52.3438H75V42.6562H64.0208V32Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.0833 32H56.9167V44.5938H44V50.4062H56.9167V63H62.0833V50.4062H75V44.5938H62.0833V32Z",
    fill: "#E62048"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M104.999 124.155L103.878 126.348C103.395 127.294 103.576 128.443 104.327 129.194C105.078 129.945 106.228 130.127 107.173 129.643L109.366 128.522L104.999 124.155Z",
    fill: "#2255EF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M151.683 91.7385L141.783 81.839L144.944 78.6778C146.323 77.2994 148.548 77.2901 149.915 78.657L154.865 83.6067C156.231 84.9736 156.222 87.199 154.844 88.5773L151.683 91.7385Z",
    fill: "#E62048"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    transform: "rotate(45 138.975 84.647)",
    fill: "#2255EF",
    d: "M138.975 84.647H152.975V128.647H138.975z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    transform: "rotate(45 141.804 81.818)",
    fill: "#fff",
    d: "M141.804 81.818H155.804V85.818H141.804z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M107.863 115.759L117.762 125.659L109.277 128.487L105.034 124.245L107.863 115.759Z",
    fill: "#F7B100"
  })));
}

export default SvgStep7;